<template>
  <el-container id="layoutContainer">
    <el-header class="layout-header">
      <div class='left-div'>
        <img :src="portraitBase64Str" />
        <!-- <span>{{ $t('c.welcome') }}: {{ personName }}</span> -->
        <span>{{ $t('c.welcome') }}</span>
      </div>
      <div class='toggle-div'>
        <el-tooltip :content="$t('c.popIndentMenuBar')" placement="right">
          <i @click="isCollapse=!isCollapse" class="el-icon-menu"></i>
        </el-tooltip>
      </div>
      <div class='middle-div'>
        <h1></h1>
      </div>
      <div class='right-div'>
        <full-screen v-model="isFullScreen"></full-screen>
        <!-- <el-tooltip :content="$t('c.notice.notice')" placement="bottom">
          <i class="el-icon-bell"></i>
        </el-tooltip>
        <el-tooltip :content="$t('c.message')" placement="bottom">
          <i class="el-icon-message"></i>
        </el-tooltip> -->
        <el-dropdown @command="handleCommand">
          <i class="el-icon-setting"></i>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="profile"><i class="el-icon-Aicon-quanjushezhi_o"></i> {{ $t('c.profile') }}</el-dropdown-item> -->
            <el-dropdown-item command="loginInfo"><i class="el-icon-Aicon-quanjushezhi_o"></i> {{ $t('c.profile') }}</el-dropdown-item>
            <el-dropdown-item command="modifyPw"><i class="el-icon-Aicon-fuwuxunhuanguanli_o"></i> {{ $t('c.changePassword') }}</el-dropdown-item>
            <!-- <el-dropdown-item command="chinese"><i class="el-icon-Aicon-zhongwen_o"></i> {{ $t('c.chinese') }}</el-dropdown-item>
            <el-dropdown-item command="english"><i class="el-icon-Aicon-yingwen_o"></i> {{ $t('c.english') }}</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
        <el-tooltip :content="$t('c.exit')" placement="bottom">
          <i class="el-icon-Aicon-dengchu" @click="signOut"></i>
        </el-tooltip>
      </div>
    </el-header>

    <el-container>
      <el-aside class="layout-aside" v-bind:class="{'layout-aside-collapse': isCollapse}">
        <el-scrollbar class="default-layout-scrollbar" layout>
          <el-menu :router="true" :default-active="$route.path" :collapse="isCollapse">
            <template v-for="menu in this.$store.state.menuTree">
              <template v-if="menu.children.length===0">
                <el-menu-item :key="menu.menuId" :index="menu.menuUri">
                  <i :class="menu.menuIcon"></i>
                  <span slot="title" style=" font-size:120%;">{{menu.menuName}}</span>
                </el-menu-item>
              </template>
              <template v-else>
                <el-submenu :key="menu.menuId" :index="menu.menuUri">
                  <template slot="title">
                    <i :class="menu.menuIcon" ></i>
                    <span  slot="title" style=" font-size:120%;">{{menu.menuName}}</span>
                  </template>
                  <el-menu-item :index="child.menuUri" v-for="child in menu.children" :key="child.menuId">
                    <i :class="menu.menuIcon"></i>
                    <span slot="title">{{child.menuName}}</span>
                  </el-menu-item>
                </el-submenu>
              </template>
            </template>
          </el-menu>
        </el-scrollbar>
      </el-aside>
      <el-main class="layout-main">
        <el-scrollbar class="default-layout-scrollbar" layout>
          <div class="layout-scrollbar-main">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="layout-breadcrumb">
              <el-breadcrumb-item v-for="menuName in _.map($route.matched,'meta.menuName')" :key="menuName + Math.random()">
                {{ menuName }}
              </el-breadcrumb-item>
            </el-breadcrumb>
            <router-view></router-view>
          </div>
        </el-scrollbar>
      </el-main>
    </el-container>
    <modify-password v-if="showModifyPassword"
      :is-login="true"
      :passwordPolicy="passwordPolicy"
      :isVisible.sync="showModifyPassword"
    >
    </modify-password>
    <user-info v-if="showUserInfo"
      :isVisible.sync="showUserInfo"
    >
    </user-info>
  </el-container>
</template>

<script>
  import {
    findIsPasswordInvalid
  } from '../api/DashBoard'
import { logout, getPortrait } from '../api/Login'
import FullScreen from '@/views/base/comp/FullScreen.vue'
import ModifyPassword from '@/views/base/comp/ModifyPassword.vue'
import UserInfo from '@/views/base/comp/UserInfo.vue'
export default {
  name: 'baseLayout',
  // 组件属性对象
  props: {
    logoImgPath: { type: String, default: '/base/img/logo.png' }
  },
  components: {
    FullScreen,
    ModifyPassword,
    UserInfo,
  },
  data() {
    return {
      // 展开/收起菜单树
      isCollapse: false,
      // 是否支持全屏显示
      isFullScreen: true,
      // 用户真实名称
      personName: '',
      // 是否显示修改密码对话框
      showModifyPassword: false,
      showUserInfo: false,
      // 修改密码的参数
      passwordPolicy: {},
      // 用户头像图片
      portraitBase64Str: require(`@/assets${this.logoImgPath}`)
    }
  },
  mounted() {
    this.personName = sessionStorage.getItem('personName')
    // 设置浏览器页签的title为项目名称
    window.document.title = this.$t('m.projectTitle')
    this.getPortrait()
    this.findPassWordLost()
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case 'profile':

          // this.$router.push({ path: '/upgrade/versionUpdate?w=2', query: { shopNo: new Date().getTime(), name: 'www' } })
          break
        case 'modifyPw':
          this.showModifyPassword = true
          this.passwordPolicy = {
            'isLogin': false,
            'reasonModify': ''
          }
          const param = JSON.parse(sessionStorage.getItem('param'))
          this.passwordPolicy = {
            passwordPolicyMinLength: param.minl,
            passwordPolicyMaxLength: param.maxl,
            passwordPolicyMaxLengthEnable: param.maxle,
            'isLogin': false,
            'reasonModify': '',
            'username': param.account
          }
          break
        case 'loginInfo':
          this.showUserInfo = true;
        case 'chinese':
          this.$i18n.locale = 'zh'
          localStorage.setItem('lang', 'zh')
          window.document.title = this.$t('m.projectTitle')
          break
        case 'english':
          this.$i18n.locale = 'en'
          localStorage.setItem('lang', 'en')
          window.document.title = this.$t('m.projectTitle')
          break
      }
    },
    //机构查询
    findPassWordLost() {
      const param = JSON.parse(sessionStorage.getItem('param'));
      var params = {"username":param.account};
      findIsPasswordInvalid(params).then(result => {
        if(result.code == 30000){
          this.handleCommand("modifyPw")
        }
      });
    },
    /**
     * 获取用户头像图片并设置和缓存
     */
    getPortrait() {
      // let paramStr = sessionStorage.getItem('param')
      // let portraitStr = localStorage.getItem('portrait')
      // if (paramStr && portraitStr) {
      //   let portrait = JSON.parse(portraitStr)
      //   let param = JSON.parse(paramStr)
      //   if (portrait.username === param.account) {
      //     // 本地已经缓存头像图片
      //     this.portraitBase64Str = portrait.portrait
      //     return
      //   }
      // }
      getPortrait().then(result => {
        if (result.data) {
          this.portraitBase64Str = result.data.portrait
          localStorage.setItem('portrait', JSON.stringify(result.data))
        } else {
          localStorage.removeItem('portrait')
        }
      })
    },
    /**
     * 用户登出
     */
    signOut() {
      logout().then(result => {
        sessionStorage.removeItem('token')
        this.$store.dispatch('signOut').then(() => {
          this.$router.push({ path: '/' })
        })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
